export default "__VITE_ASSET__9c963b82__"